export { default } from './PopularDestinationsContainer';
